module.exports = __webpack_public_path__ + "img/SambotNormal-01.0ba165b9.svg";